
import BaseButton from "../base-button/base-button.vue";
export default {
  components: { BaseButton },
};
